import getAxiosInstance from "../config/axiosConfig";
import consts from "../config/consts";

export async function getPayeurs(year) {
	const route = `/payeurs?annee=${year}`;

	const instance = await getAxiosInstance();

	try {
		const response = await instance.get(route);
		return response.data;
	} catch (error) {
		return {
			status: consts.STATUS_ERROR,
			message: consts.ERR_UNREACHABLE_SERVER
		};
	}
}

export async function getPayeur(id, annee) {
	const route = `/payeur/${id}?annee=${annee}`;

	const instance = await getAxiosInstance();

	try {
		const response = await instance.get(route);
		return response.data;
	} catch (error) {
		return {
			status: consts.STATUS_ERROR,
			message: consts.ERR_UNREACHABLE_SERVER
		};
	}
}

export async function updatePaiements(payeurId, annee, paiementsAnnee) {
	const route = `/paiements`;

	const instance = await getAxiosInstance();

	try {
		const response = await instance.put(route, { payeurId, annee, paiementsAnnee });
		return response.data;
	} catch (error) {
		return {
			status: consts.STATUS_ERROR,
			message: consts.ERR_UNREACHABLE_SERVER
		};
	}
}

export async function updatePayeur(payeurId, updatedPayeur) {
	const route = `/payeur/${payeurId}`;

	const instance = await getAxiosInstance();

	try {
		const response = await instance.put(route, { payeur: updatedPayeur });
		return response.data;
	} catch (error) {
		return {
			status: consts.STATUS_ERROR,
			message: consts.ERR_UNREACHABLE_SERVER
		};
	}
}

export async function deletePayeur(payeurId) {
	const route = `/payeur/${payeurId}`;

	const instance = await getAxiosInstance();

	try {
		const response = await instance.delete(route);
		return response.data;
	} catch (error) {
		return {
			status: consts.STATUS_ERROR,
			message: consts.ERR_UNREACHABLE_SERVER
		};
	}
}

export async function createPayeur(nom, estAnonyme, estVisible, commentaire) {
	const route = `/payeurs`;

	const instance = await getAxiosInstance();

	try {
		const response = await instance.post(route, { nom, estAnonyme, estVisible, commentaire });
		return response.data;
	} catch (error) {
		return {
			status: consts.STATUS_ERROR,
			message: consts.ERR_UNREACHABLE_SERVER
		};
	}
}
